import { Team } from '@demind-inc/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { TeamUpdateReq, teamApi } from '../api';
import { TEAM_DETAIL_QUERY_KEY, TEAM_LIST_QUERY_KEY } from '../queries';

interface UpdateTeamParams {
  teamId: string;
  teamUpdateReq: TeamUpdateReq;
}

export const useUpdateTeam = () => {
  const queryClient = useQueryClient();

  const updateTeamMutation = useMutation({
    mutationFn: ({ teamId, teamUpdateReq }: UpdateTeamParams) => {
      return teamApi.updateTeam(teamId, teamUpdateReq).then(({ data }) => data.team as Team);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TEAM_LIST_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: TEAM_DETAIL_QUERY_KEY });
    },
  });

  return {
    updateTeam: updateTeamMutation.mutateAsync,
    isUpdatingTeam: updateTeamMutation.isPending,
    ...updateTeamMutation,
  };
};
